import { Entry } from 'contentful';
import { IFeedbackCapture, FFeedbackCapture } from '@belong/ui-components';

export interface IStandardTemplate {
  contentType: string;
  searchPlaceholder: string;
  relatedArticlesHeading: string;
  popularArticlesHeading: string;
  feedbackCapture: IFeedbackCapture;
}

const FStandardTemplate = (data: Entry<any>): IStandardTemplate => {
  const { sys, fields } = data;
  const { searchPlaceholder, relatedArticlesHeading, popularArticlesHeading, feedbackCapture } = fields;

  return {
    contentType: sys.contentType.sys.id,
    searchPlaceholder,
    relatedArticlesHeading,
    popularArticlesHeading,
    feedbackCapture: FFeedbackCapture(feedbackCapture)
  };
};

export default FStandardTemplate;
